module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.fee66e712a8a08eef5805a46892932ad.woff?";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.woff
// module id = 329
// module chunks = 1